import React, { useEffect, useState } from "react";
import { api, apiError } from "@/lib/apiClient";
import { useParams, useNavigate } from "react-router-dom";
import { formatDate } from "@/lib/statuts";
import { StatutBadge } from "@/components/StatutBadge";
import { ArrowLeft, Phone, Mail, MapPin, Loader2 } from "lucide-react";

export default function ClientDetail() {
  const { id } = useParams();
  const navigate = useNavigate();
  const [c, setC] = useState(null);
  const [error, setError] = useState("");

  useEffect(() => { api.get(`/clients/${id}`).then((r) => setC(r.data)).catch((e) => setError(apiError(e))); }, [id]);

  if (error) return <div className="rounded-xl border border-rose-200 bg-rose-50 p-6 text-rose-700">{error}</div>;
  if (!c) return <div className="flex h-96 items-center justify-center"><Loader2 className="h-6 w-6 animate-spin text-slate-400" /></div>;

  const now = new Date().toISOString().slice(0, 10);
  const futures = c.visites.filter((v) => v.date_visite && v.date_visite >= now);
  const passees = c.visites.filter((v) => !v.date_visite || v.date_visite < now);

  return (
    <div className="space-y-4">
      <button onClick={() => navigate(-1)} className="flex items-center gap-1 text-sm text-slate-500 hover:text-slate-900"><ArrowLeft className="h-4 w-4" /> Retour</button>
      <h1 className="font-heading text-2xl font-extrabold tracking-tight text-slate-900">{c.prenom} {c.nom}</h1>

      <div className="grid grid-cols-1 gap-4 lg:grid-cols-3">
        <div className="rounded-xl border border-slate-200 bg-white p-5">
          <h3 className="mb-3 font-heading text-sm font-bold uppercase tracking-wide text-slate-700">Coordonnées</h3>
          <div className="space-y-2 text-sm">
            <div className="flex items-center gap-2"><Phone className="h-4 w-4 text-slate-400" /><span className="mono">{c.telephone || "—"}</span></div>
            <div className="flex items-center gap-2"><Mail className="h-4 w-4 text-slate-400" />{c.email || "—"}</div>
            <div className="flex items-start gap-2"><MapPin className="h-4 w-4 text-slate-400" /><span>{c.adresse} {c.complement_adresse}<br />{c.code_postal} {c.ville}</span></div>
          </div>
        </div>

        <div className="lg:col-span-2 space-y-4">
          <VisitesBlock title={`Rendez-vous à venir (${futures.length})`} visites={futures} navigate={navigate} />
          <VisitesBlock title={`Rendez-vous passés (${passees.length})`} visites={passees} navigate={navigate} />
        </div>
      </div>
    </div>
  );
}

function VisitesBlock({ title, visites, navigate }) {
  return (
    <div className="rounded-xl border border-slate-200 bg-white p-5">
      <h3 className="mb-3 font-heading text-sm font-bold uppercase tracking-wide text-slate-700">{title}</h3>
      {visites.length === 0 ? <p className="text-sm text-slate-400">Aucun.</p> : (
        <div className="divide-y divide-slate-100">
          {visites.map((v) => (
            <button key={v.id} onClick={() => navigate(`/visites/${v.id}`)} className="flex w-full items-center justify-between py-2.5 text-left hover:bg-slate-50">
              <div className="flex items-center gap-3">
                <span className="mono text-xs font-semibold text-amber-600">{v.numero_dossier}</span>
                <span className="text-sm text-slate-700">{v.date_visite ? formatDate(v.date_visite) : "Non planifiée"}</span>
                <span className="text-xs text-slate-400">{v.technicien_nom}</span>
              </div>
              <StatutBadge code={v.statut} color={v.statut_color} label={v.statut_label} />
            </button>
          ))}
        </div>
      )}
    </div>
  );
}
